import { ManagementEffects } from './management/management.effects';
import { OperationEffects } from './operation/operation.effects';

export const DashboardEffects = [ManagementEffects, OperationEffects];
